import { getCalculatedText, storage } from 'core';
import { logout } from 'lib';
import { store } from '../store';
import { Api } from './';

async function loginWithToken(latestComments = false) {
  const res = await Api.post(
    '/users/loginWithToken',
    latestComments ? { latestComments: true } : null
  );

  if (!res || typeof res === 'string') return logout();

  await storage.setItem('token', res.token);

  // Add read more previews to the captions
  const homePosts = await Promise.all(
      (res.home?.posts || []).map(async (x) => ({
        ...x,
        calculatedText: await getCalculatedText(x.caption)
      }))
    ),
    userPosts = await Promise.all(
      (res.user?.posts || []).map(async (x) => ({
        ...x,
        calculatedText: await getCalculatedText(x.caption)
      }))
    );

  res.home.posts = homePosts;
  res.user.posts = userPosts;

  store.dispatch({
    type: 'INITIAL_DATA',
    payload: res
  });

  return true;
}

export default loginWithToken;
